exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[class*=\"col-\"][data-v-409beb97] {\n  padding: 0;\n}\n.contact-header[data-v-409beb97] {\n  font-size: 2rem;\n}\n.contact-content[data-v-409beb97] {\n  font-size: 1.6rem;\n}\n.separator[data-v-409beb97] {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #5cbfd6;\n  margin: 0.5rem auto 1rem auto;\n  padding: 0;\n  width: 80%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-409beb97","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/information/GeneralInformation.vue
// module id = 1619
// module chunks = 0